export default {"src":"/_next/static/media/blue-paw.b52514d1.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};